import React, { useState, useEffect } from 'react';
import SharedHelmet from "../Helmet";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import imageUrl from "../../../images/mother.webp";
import BlinkingText from '../../BlinkingText';
import RelatedLinks from '../RelatedLinks';
import MainCalculatorsList from './MainCalculators';

const TITLE = "Décompte jusqu'à la Fête des Mères 2026 - Jours restants";
const DESCRIPTION = "Combien de jours restants jusqu'à la Fête des Mères 2026 ? Le décompte jusqu'à la Fête des Mères vous fournit des informations précises sur la date de cet événement spécial, combien de jours restent pour célébrer les mamans.";
const KEYWORDS = "Fête des Mères 2026, date Fête des Mères, décompte Fête des Mères, combien de jours jusqu'à la Fête des Mères 2026";
const OG_URL = "https://do-calculate.com/articles-fr/motherday";

function MothersDay() {
    const calculateTimeLeft = (targetDate) => {
        const now = new Date();
        const difference = targetDate - now;
        let timeLeft = {};
        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60),
            };
        }
        return timeLeft;
    };

    // In France, Mother's Day is the last Sunday of May
    const initialDate = new Date("2026-05-31T00:00:00"); // Last Sunday of May 2026
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(initialDate));

    useEffect(() => {
        const timer = setTimeout(() => {
            setTimeLeft(calculateTimeLeft(initialDate));
        }, 1000);
        return () => clearTimeout(timer);
    }, [timeLeft]);

    const mothersDayDates = [
        { name: "Fête des Mères 2026", date: new Date("2026-05-31T00:00:00") },
        { name: "Fête des Mères 2027", date: new Date("2027-05-30T00:00:00") },
        { name: "Fête des Mères 2028", date: new Date("2028-05-28T00:00:00") },
        { name: "Fête des Mères 2029", date: new Date("2029-05-27T00:00:00") },
        { name: "Fête des Mères 2030", date: new Date("2030-05-26T00:00:00") },
    ];

    const dayName = initialDate.toLocaleDateString('fr-FR', { weekday: 'long' });

    return (
        <div className="ltr">
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
            />
            <div className="row">
                <FirstAds />
            </div>
            <h1 className="p-3 mb-2 bg-success text-white">
                Décompte jusqu'à la Fête des Mères 2026
            </h1>
            <div>
                <BlinkingText text={`Décompte jusqu'à la Fête des Mères : la Fête des Mères 2026 devrait avoir lieu le ${dayName} 31/05/2026.`} />
            </div>
            <div className="row">
                <div id="timer" style={{ width: '100%' }}>
                    <table style={{ width: '100%', textAlign: 'center', borderCollapse: 'collapse', border: '1px solid #ccc', fontSize: '24px' }}>
                        <thead>
                            <tr>
                                <th className="bmi-header">Jours</th>
                                <th className="bmi-header">Heures</th>
                                <th className="bmi-header">Minutes</th>
                                <th className="bmi-header">Secondes</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{timeLeft.days ?? 0}</td>
                                <td>{timeLeft.hours ?? 0}</td>
                                <td>{timeLeft.minutes ?? 0}</td>
                                <td>{timeLeft.seconds ?? 0}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="row">
                <SecondAds />
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <div>
                        <h2 className="p-3 mb-2 bg-success text-white" style={{ fontSize: '28px', textAlign: 'center' }}>
                            Prochaines dates de la Fête des Mères
                        </h2>
                        <table style={{ fontSize: '20px', width: '100%', textAlign: 'center', borderCollapse: 'collapse', border: '2px solid #ccc', borderRadius: '8px', overflow: 'hidden' }}>
                            <thead>
                                <tr style={{ backgroundColor: '#f2f2f2' }}>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>Fête des Mères</th>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>Date</th>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>Jours restants</th>
                                </tr>
                            </thead>
                            <tbody>
                                {mothersDayDates.map((item, index) => (
                                    <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9' }}>
                                        <td style={{ padding: '12px' }}>{item.name}</td>
                                        <td style={{ padding: '12px' }}>{item.date.toLocaleDateString('fr-FR')}</td>
                                        <td style={{ padding: '12px' }}>
                                            {Math.max(0, calculateTimeLeft(item.date).days ?? 0)} jours
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="col-sm-4 col-md-4">
                    <MainCalculatorsList />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <h3 className="p-3 mb-2 bg-success text-white">Décompte jusqu'à la Fête des Mères 2026</h3>
                    <p>
                        Dans cet article, nous vous proposons un décompte détaillé jusqu'à la Fête des Mères, afin que vous puissiez être informé à tout moment du nombre de jours restants jusqu'à cette journée spéciale. Beaucoup d'entre nous se demandent combien de jours restent jusqu'à la Fête des Mères. C'est pourquoi, dans cet article, nous vous présentons le décompte jusqu'à la Fête des Mères, vous permettant de savoir combien de temps reste pour préparer une belle surprise à votre maman.
                    </p>
                    <p>
                        La Fête des Mères 2026 aura lieu le {dayName} 31/05/2026.
                        Vous pouvez voir le décompte jusqu'à la Fête des Mères dans cet article.
                    </p>
                    <hr />
                    <RelatedLinks />
                    <hr />
                    <h3 className="p-3 mb-2 bg-success text-white">
                        Calculer les jours restants jusqu'à la Fête des Mères
                    </h3>
                    <p>
                        Grâce au programme de décompte de la Fête des Mères, vous pouvez savoir combien de jours restent jusqu'à cette occasion spéciale. Profitez de ce décompte pour préparer un cadeau, une surprise ou une attention particulière pour votre maman et lui montrer votre amour et votre reconnaissance.
                    </p>
                    <h3 className="p-3 mb-2 bg-success text-white">La Fête des Mères</h3>
                    <p>
                        La Fête des Mères est une célébration annuelle dédiée à honorer les mères et à leur exprimer notre gratitude et notre amour. En France, la Fête des Mères est célébrée le dernier dimanche de mai (ou le premier dimanche de juin si le dernier dimanche de mai coïncide avec la Pentecôte). C'est une journée où les enfants et les familles expriment leur affection et leur reconnaissance envers leurs mères à travers des cadeaux, des fleurs et des moments de partage.
                    </p>
                    <div>
                        <br />
                        <img
                            src={imageUrl}
                            alt="Décompte jusqu'à la Fête des Mères 2026"
                            width="800"
                            height="450"
                            style={{ width: '100%', height: 'auto', maxWidth: '800px' }}
                            loading="lazy"
                        />
                        <br />
                    </div>
                </div>
            </div>
            <MobileUnderCalAds />
        </div>
    );
}

export default MothersDay;
